import { createContext } from 'react';

const PubSubContext = createContext();

export default PubSubContext;
